import * as LucideIcons from "lucide-react";
import type { LucideIcon } from "lucide-react";
import {
  DEFAULT_TOOL_ICON_KEY,
  type ToolIconKey,
} from "@/data/tools/icon-keys";

type ToolIconProps = {
  icon: ToolIconKey;
  size?: number;
  className?: string;
};

export default function ToolIcon({
  icon,
  size = 20,
  className,
}: ToolIconProps) {
  const iconRecord = LucideIcons as Record<string, unknown>;
  const requestedIcon = iconRecord[icon];
  const fallbackIcon = iconRecord[DEFAULT_TOOL_ICON_KEY];
  const IconComponent =
    typeof requestedIcon === "function"
      ? (requestedIcon as LucideIcon)
      : (fallbackIcon as LucideIcon);

  return <IconComponent size={size} className={className} />;
}
